import * as React from 'react';

import { observer } from 'mobx-react';
import { AppHeader } from '@teliaee/telia-megamenu';
import { useStores } from "@stores/RootStore";

const HeaderContainer = () => {
  const { menuStore, translateStore } = useStores();

  if (translateStore.initializationCompleted) {
    return <AppHeader {...menuStore.getHeaderProps()} />;
  }
  return null;
}

export default observer(HeaderContainer);
